import { ListItemText } from "@mui/material";
import { format } from "date-fns";
import { StyledRgrl } from "../../../../styled/Prevencion";

const DatosDecretoPresentacion = ({ data }) => {

  return (
    <StyledRgrl.List>
      <StyledRgrl.ListItem key="fechaPresentacion">
        <StyledRgrl.Label>Fecha Presentación</StyledRgrl.Label>
        <ListItemText secondary={format(new Date(), "dd/MM/yyyy")} />
      </StyledRgrl.ListItem>
      <StyledRgrl.ListItem key="decreto">
        <StyledRgrl.Label>Decreto</StyledRgrl.Label>
        <ListItemText
          secondary={data?.nombre ? data?.nombre : "Sin Información"}
        />
      </StyledRgrl.ListItem>
      <StyledRgrl.ListItem key="totalTrabajadores">
        <StyledRgrl.Label>Total Trabajadores</StyledRgrl.Label>
        <ListItemText
          secondary={
            data?.totalTrabajadoresEstablecimientos
              ? data.totalTrabajadoresEstablecimientos
              : "Sin Información"
          }
        />
      </StyledRgrl.ListItem>
      <StyledRgrl.ListItem key="superficie">
        <StyledRgrl.Label>Superficie</StyledRgrl.Label>
        <ListItemText
          secondary={data?.superficie ? data?.superficie : "Sin Información"}
        />
      </StyledRgrl.ListItem>
      <StyledRgrl.ListItem
        key="observaciones"
        sx={{ display: "flex", alignItems: "flex-start" }}
      >
        <StyledRgrl.Label>Observaciones</StyledRgrl.Label>
        <ListItemText
          sx={{ display: "block", whiteSpace: "pre-line" }}
          secondary={
            data?.observaciones ? data.observaciones : "Sin Información"
          }
        />
      </StyledRgrl.ListItem>
    </StyledRgrl.List>
  );
};

export default DatosDecretoPresentacion;
